import * as React from 'react';

class Kontakt extends React.Component {

    public render() {
        return (
            <div>
                Kontakt
            </div>
        );
    }
}

export default Kontakt;



// WEBPACK FOOTER //
// ./src/Kontakt/Kontakt.tsx